import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { RenterRegFormService } from '@accounts/operator/services/renter-reg-form.service';
import { RenterForm } from '@core/components/abstract/renter-form';

@Component({
  selector: 'renter-driving-license',
  templateUrl: './renter-driving-license.component.html',
  styleUrls: ['./renter-driving-license.component.scss']
})
export class RenterDrivingLicenseComponent extends RenterForm implements OnInit {

  maxDateIssuedAt = new Date();

  constructor(
    private renterFormService: RenterRegFormService
  ) {
    super();
  }

  get form(): FormGroup {
    try {
      return this.renterFormService.renterForm.get('driver_license') as FormGroup;
    } catch (e) {
      throw new Error('Renter form was not built');
    }
  }

  ngOnInit() {
  }

}
